<template>
  <b-modal ref="publicWinnersModal" size="lg">
    <h5>{{ header }}</h5>
    <table>
      <tr>
        <th>Platz</th>
        <th>Punkte</th>
        <th>Name</th>
        <th>Bundesland</th>
        <th>Stadt</th>
        <th>Schule</th>
      </tr>

      <tr v-for="w in winners">
        <td>{{ w.price }}</td>
        <td>{{ w.points }}</td>
        <td>{{ w.name }}</td>
        <td>{{ w.state }}</td>
        <td>{{ w.city }}</td>
        <td>{{ w.school }}</td>
      </tr>
    </table>
  </b-modal>
</template>
<script>
export default {
  name: 'PublicWinnersModal',
  props: ['competition', 'age'],
  data: function () {
    return {
      winners: null
    }
  },
  computed: {
    header: function () {
      return 'Top 100 der Klassenstufe ' + this.age
    }
  },
  methods: {
    show: function () {
      this.axios.get('/competitions/' + this.competition.id + '/prices/public?age=' + this.age)
        .then((rsp) => {
          this.winners = rsp.data.winners
          this.$refs.publicWinnersModal.show()
        })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/competitions/prices/PublicModal.vue